'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

var _ramda = require('ramda');

var _getNodesRects = require('./getNodesRects');

var _getNodesRects2 = _interopRequireDefault(_getNodesRects);

var _pureGraph = require('pure-graph');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getProjectDimentions = function getProjectDimentions(project) {
  var graph = project.graph;
  var nodesData = project.nodesData;


  var nodes = (0, _pureGraph.getNodes)(graph);
  var nodesRects = (0, _getNodesRects2.default)(project);

  var mappedNodesData = nodes.map(function (id) {
    return { id: id, data: nodesData[id] };
  });

  var mappedNodes = mappedNodesData.map(function (node) {
    var id = node.id;
    var _node$data = node.data;
    var x = _node$data.x;
    var y = _node$data.y;
    var _nodesRects$id = nodesRects[id];
    var width = _nodesRects$id.width;
    var height = _nodesRects$id.height;

    return _extends({ id: id, x: x, y: y, width: width, height: height });
  });

  // get the minima and maxima
  var minByX = mappedNodes.reduce((0, _ramda.minBy)((0, _ramda.prop)('x')), { x: Infinity });
  var maxByX = mappedNodes.reduce((0, _ramda.maxBy)((0, _ramda.prop)('x')), { x: -Infinity });

  var minByY = mappedNodes.reduce((0, _ramda.minBy)((0, _ramda.prop)('y')), { y: Infinity });
  var maxByY = mappedNodes.reduce((0, _ramda.maxBy)((0, _ramda.prop)('y')), { y: -Infinity });

  var width = maxByX.x - minByX.x + (maxByX.width + minByX.width) / 2;
  var height = maxByY.y - minByY.y + (maxByY.height + minByY.height) / 2;

  return { width: width, height: height, minByX: minByX, maxByX: maxByX, minByY: minByY, maxByY: maxByY };
};

exports.default = getProjectDimentions;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/utils/getProjectDimentions.js
// module id = 226
// module chunks = 1